import React from "react";

export function EmptyTodos() {
    return <p>!Crea tu primer TODO!</p>
};